import moment from 'moment';

const UTC_AWARE_TIMESTAMP_FORMAT: string = 'YYYY-MM-DD HH:mm:ss.SSSSSZ';

export const getUtcFormatted = (dateTime: Date | null): string | null => dateTime && moment(dateTime).utc().format(UTC_AWARE_TIMESTAMP_FORMAT);
